/**
 * Small, card-sized variants of the Montessori-koulu category heroes.
 *
 * The full-size JPEGs (1280×720) are only needed as article heroes / OG
 * images. Teaser cards render at ~400 CSS px, so shipping the full file
 * wastes bandwidth on mobile. These build-time WebP/AVIF variants keep the
 * same crops at a fraction of the weight.
 */
// @ts-expect-error vite-imagetools transforms the query at build time
import perusteetWebp from "@/assets/hub/perusteet.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import perusteetAvif from "@/assets/hub/perusteet.jpg?format=avif&w=720&quality=62";
// @ts-expect-error vite-imagetools transforms the query at build time
import vauvaWebp from "@/assets/hub/vauva.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import vauvaAvif from "@/assets/hub/vauva.jpg?format=avif&w=720&quality=62";
// @ts-expect-error vite-imagetools transforms the query at build time
import taaperoWebp from "@/assets/hub/taapero.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import taaperoAvif from "@/assets/hub/taapero.jpg?format=avif&w=720&quality=62";
// @ts-expect-error vite-imagetools transforms the query at build time
import itsenaisyysWebp from "@/assets/hub/itsenaisyys.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import itsenaisyysAvif from "@/assets/hub/itsenaisyys.jpg?format=avif&w=720&quality=62";
// @ts-expect-error vite-imagetools transforms the query at build time
import kotiWebp from "@/assets/hub/koti.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import kotiAvif from "@/assets/hub/koti.jpg?format=avif&w=720&quality=62";
// @ts-expect-error vite-imagetools transforms the query at build time
import motoriikkaWebp from "@/assets/hub/motoriikka.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import motoriikkaAvif from "@/assets/hub/motoriikka.jpg?format=avif&w=720&quality=62";
// @ts-expect-error vite-imagetools transforms the query at build time
import vanhemmanOpasWebp from "@/assets/hub/vanhemman-opas.jpg?format=webp&w=720&quality=76";
// @ts-expect-error vite-imagetools transforms the query at build time
import vanhemmanOpasAvif from "@/assets/hub/vanhemman-opas.jpg?format=avif&w=720&quality=62";

import type { CategoryId } from "./montessori-koulu-posts";

export interface CardHero {
  webp: string;
  avif: string;
}

export const CATEGORY_HERO_CARD: Record<CategoryId, CardHero> = {
  perusteet: { webp: perusteetWebp as string, avif: perusteetAvif as string },
  vauva: { webp: vauvaWebp as string, avif: vauvaAvif as string },
  taapero: { webp: taaperoWebp as string, avif: taaperoAvif as string },
  itsenaisyys: { webp: itsenaisyysWebp as string, avif: itsenaisyysAvif as string },
  koti: { webp: kotiWebp as string, avif: kotiAvif as string },
  motoriikka: { webp: motoriikkaWebp as string, avif: motoriikkaAvif as string },
  "vanhemman-opas": {
    webp: vanhemmanOpasWebp as string,
    avif: vanhemmanOpasAvif as string,
  },
};
